import React from 'react';
import Providers from '../../pages/Providers';

export default function ProvidersViewContainer({ records, providers, permissions, onAddProvider, onUpdateProvider, onGrantPermission }) {
  return (
    <Providers
      records={records}
      providers={providers}
      permissions={permissions}
      onAddProvider={onAddProvider}
      onUpdateProvider={onUpdateProvider}
      onGrantPermission={onGrantPermission}
    />
  );
}
